export class Street {
    public streetId: string;
    public polygon: string;
    public streetName: string;
    public houseNumbers: string;

    constructor();
    constructor(json: any);
    constructor(json?: Street) {
        if (json) {
            this.streetId = json.streetId;
            this.polygon = json.polygon;
            this.streetName = json.streetName;
            this.houseNumbers = json.houseNumbers;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/sector/street.ts